import { Vraag } from './vraag';
import { VragenboomMetadata } from './vragenboom-metadata';

export class Vragenboom {
  contentId: string;
  vragenboomMetadata: VragenboomMetadata;
  vragen: Vraag[]; 
}
